/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

import { TAB_FABRICATION } from 'shared/product_tabs/tabs/tabType';
import { selectDataForBomSelection } from 'shared/product_tabs/tab_parts/slice/selectors';
import { openBomFile } from 'shared/product_tabs/tab_parts/slice/process_file';
import { updateShowBomSelection } from 'shared/product_tabs/tab_parts/bomSlice';

// const BomFileFoundMessage = (props) => {
//   return (
//     <div>
//       We detected a Bom file, please confirm that is the correct file and
//       proceed.
//     </div>
//   );
// };

const FileNode = ({
  file,
  directory_path: directoryPathProp = '',
  onSelectBomFile,
  checked: checkedProp = false,
}) => {
  let classFileNode = 'file-node';
  let checked = checkedProp;
  let directory_path = directoryPathProp;

  if (file.endsWith('.xlsx') || file.endsWith('.xls')) {
    checked = true;
  }

  if (checked) {
    classFileNode += ' selected';
  }

  if (directory_path === '') {
    directory_path = file;
  } else {
    directory_path += file;
  }

  return (
    <div className={classFileNode}>
      <label className='custom-radio-button mb-0'>
        {file}
        {checked && (
          <>
            &nbsp;
            <input
              type='radio'
              name='bom_file'
              value={directory_path}
              onChange={() => onSelectBomFile(directory_path)} />
          </>
        )}
        <span className='checkmark' />
      </label>
    </div>
  );
};

const DirectoryTree = ({
  tree,
  depth = 0,
  directory_path = '',
  onSelectBomFile,
}) => {
  const onChange = () => {};

  if (typeof tree === 'string') {
    return (
      <FileNode
        file={tree}
        directory_path={directory_path}
        onSelectBomFile={onChange} />
    );
  }

  return tree.map((item, i) => (
    <React.Fragment key={`file-item-${i}`}>
      {typeof item === 'string' ? (
        <FileNode
          file={item}
          directory_path={directory_path}
          onSelectBomFile={onSelectBomFile} />
      ) : (
        <div className='root'>
          <div className='path'>
            <i className='far fa-folder-open' />
            {item.data}/<i className='fas fa-angle-down' />
          </div>
          <div style={{ paddingLeft: (depth + 1) * 15 }}>
            <DirectoryTree
              tree={item['children']}
              depth={depth + 1}
              directory_path={`${item['data']}/`}
              onSelectBomFile={onSelectBomFile} />
          </div>
        </div>
      )}
    </React.Fragment>
  ));
};

const FileStructure = ({ directory, onSelectBomFile }) => (
  <div className='file-structure'>
    <DirectoryTree
      tree={directory['children']}
      onSelectBomFile={onSelectBomFile} />
  </div>
);

const FileExtractor = ({ activeTab, directory, onSelectBomFile }) => (
  <div className='file-extractor'>
    <p>
      {activeTab === TAB_FABRICATION &&
        'Please select the BOM associated with this PCB project.'}
      {activeTab !== TAB_FABRICATION &&
        'Select the BOM associated with this project.'}
    </p>
    <div className='file-structure-content'>
      <FileStructure
        directory={directory}
        onSelectBomFile={onSelectBomFile} />
    </div>
  </div>
);

const ExtractZipFileTool = (props) => {
  const dispatch = useDispatch();
  const [bom_file, setBomFile] = useState('');

  const { activeTab, directory, show } = useSelector(selectDataForBomSelection);

  const { onShow, onCloseZipFileTool } = props;

  if (!directory || Object.keys(directory).length === 0) return null;

  const onHide = () => {
    dispatch(updateShowBomSelection(false));
    onCloseZipFileTool();
  };

  const clickBtn = () => {
    dispatch(openBomFile(bom_file));
  };

  return (
    <Modal
      className='file-extractor-modal'
      show={show}
      onShow={onShow}
      onHide={onHide}
      centered>
      <Modal.Header closeButton>
        <Modal.Title>BOM FILE SELECTION</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FileExtractor
          activeTab={activeTab}
          directory={directory}
          onSelectBomFile={setBomFile} />
      </Modal.Body>
      <Modal.Footer>
        <button
          type='button'
          className='btn btn-outline-primary'
          onClick={onHide}>
          CANCEL
        </button>
        <button type='button' className='btn btn-primary' onClick={clickBtn}>
          OPEN BOM
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExtractZipFileTool;
